import React from 'react'
import './footer.css';

const Footer = () => {
  return (
    <div>
        <section className='footer mt-5'>
            <div className='footer-section text-center'>
                 <p>AmulRaj S | 2026 All Rights Reserved. Privacy Policy</p>
            </div>
        </section>

    </div>
  )
}

export default Footer
